import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Clock } from "lucide-react";
import { useSEO } from "@/lib/seo";

// Page de confirmation générique (contact, contribution, newsletter).
export default function Merci({ kicker, title, message, steps = [], note, testid = "merci-page" }) {
  useSEO({ title, description: message, noindex: true });
  return (
    <div data-testid={testid} className="mx-auto max-w-2xl px-5 md:px-8 py-20 md:py-24 text-center">
      <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-orange text-ink">
        <CheckCircle2 size={28} strokeWidth={2.2} />
      </span>
      <p className="mt-8 text-orange font-bold text-sm uppercase tracking-wide">{kicker}</p>
      <h1 className="mt-3 font-display font-black text-4xl md:text-5xl uppercase leading-[0.95] text-ink break-words">
        {title}
      </h1>
      <p className="mt-6 text-lg text-muted-ink leading-relaxed">{message}</p>

      {steps.length > 0 && (
        <div className="mt-10 text-left bg-white border border-line rounded-[16px] p-6 md:p-7" style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.04)" }}>
          <p className="font-display font-black text-lg uppercase text-ink leading-none">Et maintenant ?</p>
          <ul className="mt-4 space-y-3">
            {steps.map((s, i) => (
              <li key={i} className="flex items-start gap-3 text-muted-ink leading-relaxed">
                <span className="mt-2 h-2 w-2 rounded-[2px] bg-orange shrink-0" aria-hidden="true" />
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {note && (
        <p className="mt-6 inline-flex items-start gap-2 text-sm text-muted-ink leading-relaxed text-left">
          <Clock size={15} className="mt-0.5 shrink-0 text-ink" />
          <span>{note}</span>
        </p>
      )}

      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          data-testid="merci-home-link"
          className="inline-flex items-center gap-2 bg-ink text-paper font-bold uppercase tracking-wide px-6 py-3.5 rounded-[10px] hover:bg-orange hover:text-ink transition-colors duration-200"
        >
          Retour à l'accueil <ArrowRight size={17} />
        </Link>
        <Link
          to="/a-propos"
          data-testid="merci-apropos-link"
          className="inline-flex items-center gap-2 border-2 border-ink text-ink font-bold uppercase tracking-wide px-6 py-3.5 rounded-[10px] hover:bg-ink hover:text-paper transition-colors duration-200"
        >
          À propos du projet
        </Link>
      </div>
    </div>
  );
}
